<template>
  <div id="TopNav">
    <div class="content-container">
    <b-navbar class="pl-5 py-0 desktop row">
      <b-navbar-brand @click="$router.push({name: 'eap'})" class="col-3 d-flex align-items-start">
        <img src="/img/logo-spectrum-life.svg" class="ml-0"/>
      </b-navbar-brand>
      <b-navbar-nav class="ml-auto brand-secondary col-9" >
        <b-nav-item class="mx-4 brand-primary" :class="{active : currentPage === 'eap'}" @click="$router.push({name: 'eap'})">EAP</b-nav-item>
        <!--<b-nav-item class="mx-5 brand-primary" :class="{active : currentPage === 'eapUK'}" @click="$router.push({name: 'eapUK'})">EAP UK</b-nav-item> -->
        <b-nav-item class="mx-4 brand-primary" :class="{active : currentPage === 'wellbeing'}" @click="$router.push({name: 'wellbeing'})">Courses</b-nav-item>
        <b-nav-item class="mx-4 brand-primary"  :class="{active : currentPage === 'info'}" @click="$router.push({name: 'info'})">General Info</b-nav-item>
        <b-nav-item class="mx-4 brand-primary" :class="{active : currentPage === 'beCalm'}" @click="$router.push({name: 'beCalm'})">Be Calm</b-nav-item>
      </b-navbar-nav>
    </b-navbar>
    </div>
  </div>
</template>

<script>

export default {
  name: "TopNav",
  components: {},
  data() {
    return {

    };
  },
  methods: {
  },
  computed: {
      currentPage(){
        return this.$route.name
      },
  },

};
</script>
<style lang="less">
#TopNav {
  @import "../../assets/_theme-0";
  background: linear-gradient(to right, #fff 0%,#fff 25%,@brand-secondary 25%, @brand-secondary 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  .navbar {
    .nav-item {
      position: relative;
      a {
        font-size: 1.7rem;
        font-family: "FilsonProBook", sans-serif;

      }
      &.active{
        a{
        }
        &:before{
          content: "";
          width: calc(100% + 20px);
          height: 18px;
          display: block;
          background-color: #fff;
          position: absolute;
          top: -30px;
          transform: translateX(-10px);
        }
      }
    }
    .navbar-brand{
      width: 180px;
      background-color: #fff;
      text-align: left;
      cursor: pointer;
      z-index: 5;
      height: 80px;
      padding: 5px 0;
      img{
        max-width: 100%;
        margin: auto;
        height: 60px;
        z-index: 5;
      }
      &::after{
        z-index: -1;
        position: absolute;
        right: 0;
        top: 0;
        content: '';
        display: block;
        background-color: white;
        width: 80px;
        height: calc(100% + 1px);
        border-right: 9px solid #87d3dc;
        transform: translateX(40px) skewX(-40deg);
      }
    }
    .navbar-nav {
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: transparent;
      padding-left: 80px;
      .nav-item {
        a {
          color: #fff;
        }
        &.active, &:hover {
          a {
            font-weight: 600;
            color: @brand-primary;
          }
          &:before {
            background-color: @brand-primary;
          }
        }
      }
    }
    .dropdown-menu{
      width: 400px;
      height: 255px;
      margin-left: 1px;
      padding: 20px 40px;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 4px 4px 15px rgba(0, 0, 0, 0.3);
      transform: translate(-50%, 10px);
      position: absolute;
      left: 50%;
      &:after{
        position: absolute;
        content: '';
        width: 0;
        height: 0;
        top: -18px;
        left: 50%;
        transform: translateX(-50%);
        border-left: 16px solid transparent;
        border-right: 16px solid transparent;
        border-bottom: 18px solid #ffffff;
      }
      .dropdown-item {
        text-align: center;
        .image-wrap {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 65px;
          height: 65px;
          margin: auto auto 15px auto;
          border-radius: 50%;
          background: #FFFFFF;
          box-shadow: 4px 4px 15px rgba(0, 0, 0, 0.3);
          img {
            height: 30px;
          }
        }
        .dropdown-label{
          color: #3a4961;
          font-size: 1.4rem;
          line-height: 1;
          margin-bottom: 19px;
          text-align: center;
        }
        &:hover{
          background-color: transparent;
          .dropdown-label{
            font-family: FilsonProBold;
            background-color: transparent;
            position: relative;
            &:before {
              position: absolute;
              content: '';
              width: 10px;
              height: 10px;
              top: 85%;
              right: -5px;
              transform: translateY(-50%);
              background: url('/img/navigation/arrow.svg') 0 0 no-repeat;
              background-size: contain;
            }
          }
        }
        &:active{
          background-color: transparent !important;
        }
      }
    }
  }
}
</style>